/**
 * 本文件是消息函数模块
 * @author 笑三少
 */
import { ElMessage } from 'element-plus'
import type { MessageParams } from 'element-plus'

// 默认配置
const defaultConfig = {
  message: '操作成功',
  plain: true,
  placement:'top',
  type: 'info',
}

// 成功消息
export function successMessage(message?: string) {
  return ElMessage({
    ...defaultConfig,
    message: message || '操作成功',
    type: 'success'
  })
}

// 普通消息
export function normalMessage(message?: string) {
  return ElMessage({
    ...defaultConfig,
    message: message || '操作成功',
    type: 'info'
  })
}

// 警告消息
export function warningMessage(message?: string) {
  return ElMessage({
    ...defaultConfig,
    message: message || '操作成功',
    type: 'warning'
  })
}

// 错误消息
export function errorMessage(message?: string) {
  return ElMessage({
    ...defaultConfig,
    message: message || '操作失败',
    type: 'error'
  })
}
